import { render } from "./FormatLS.vue?vue&type=template&id=049e08ae&scoped=true"
import script from "./FormatLS.vue?vue&type=script&lang=js"
export * from "./FormatLS.vue?vue&type=script&lang=js"

import "./FormatLS.vue?vue&type=style&index=0&id=049e08ae&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-049e08ae"]])

export default __exports__